import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import useEntity from '@/entity/hooks/use-entity';
import { getEntityLabel } from '../chat-input/mention-extension/utils';

// A person/business's readable name, or null when there isn't one. Entity names are sensitive vault
// data usually absent from the resource frame. Recover gracefully on every failure path: the name
// fields can be missing or undecryptable (getEntityLabel throws / returns the fp_id), so callers can
// fall back to the identifier rather than ever echoing an id as a name.
export const entityDisplayName = (entity: Entity): string | null => {
  let label: string | null = null;
  try {
    label = getEntityLabel(entity);
  } catch {
    label = null;
  }
  return label && !label.startsWith('fp_') ? label : null;
};

// Resolve + render an entity's readable name from its fp_id, falling back to `fallback` (typically
// the fp_id) when it can't be resolved. Used by the inline resource markers; the Context Explorer
// resolves names in a batch (see use-entity-names) so it can search by the shown name.
export const EntityResourceName = t0 => {
  const $ = _c(5);
  const {
    fpId,
    fallback
  } = t0;
  const {
    data: entity
  } = useEntity(fpId);
  let t1;
  if ($[0] !== entity || $[1] !== fallback) {
    t1 = entity && entityDisplayName(entity) || fallback;
    $[0] = entity;
    $[1] = fallback;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <>{t1}</>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default EntityResourceName;